import { render } from "./platformAccount.vue?vue&type=template&id=3620a9c4&scoped=true"
import script from "./platformAccount.vue?vue&type=script&lang=js"
export * from "./platformAccount.vue?vue&type=script&lang=js"

import "./platformAccount.vue?vue&type=style&index=0&id=3620a9c4&scoped=true&lang=css"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3620a9c4"]])

export default __exports__